import PropTypes from 'prop-types';


import {geoConstants} from '../../Geo';


export const DISTRIBUTION_SHAPE = PropTypes.shape({
    countryAlpha2: geoConstants.COUNTRY_ALPHA2_SHAPE,
    isPrimary: PropTypes.bool,
    reachDigital: PropTypes.number,
    reachPrint: PropTypes.number
});


export const DISTRIBUTIONS_SHAPE = PropTypes.arrayOf(DISTRIBUTION_SHAPE);
